import { render } from "./LimitReached.vue?vue&type=template&id=d191bc42&scoped=true"
import script from "./LimitReached.vue?vue&type=script&lang=js"
export * from "./LimitReached.vue?vue&type=script&lang=js"

import "./LimitReached.vue?vue&type=style&index=0&id=d191bc42&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src801691255/src/serverlesspressoV3/frontends/vue-order-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d191bc42"]])

export default __exports__